<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;display: flex;justify-content: flex-end;">
          <el-tooltip class="item" effect="dark" placement="bottom">
            <el-button type="primary" @click="back()">返回</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="没有需要的名称,点我添加" placement="bottom">
            <el-button type="primary" @click="addGroupDetail()">添加名称</el-button>
          </el-tooltip>
        </div>

        <div style="padding: 10px;">
          <el-table border :data="inputerDetailList" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="inputer_name" label="名称">
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <div class="actionStyle">
                  <div>
                    <el-button @click.native.prevent="delInpterName(scope.$index)" type="text" size="small">
                      删除
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delInputerNameRecord">删 除</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--添加组-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="添加名称" :visible.sync="addInputerNameDialogVisible">
      <el-form>
        <div>
          <div>
            <div>组内名单：</div>
            <el-input type="textarea" :rows="6" placeholder="请输入内容,一行一个" v-model="group_detail">
            </el-input>
          </div>

        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addInputerDetailList">添加</el-button>
        <el-button @click="addInputerNameDialogVisible=false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        inputerDetailList: [],
        addInputerNameDialogVisible: false,
        group_detail: '',
        group_name: '',
        group_id: '',
        inputer_id: '',

        msg: '',
        dialogVisible: false

      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      // this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username
      this.group_id = this.$route.params.group_id

      // this.loadDateList()
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_load_group_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              group_id: that.group_id
            }
          }).then(function(response) {
            that.inputerDetailList = response.data.inputer_list
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state

        if (typeof (state) === 'undefined' || state === 1) {
          return '未发放'
        }

        if (state === 2) {
          return '正在填写'
        }

        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages

        if (typeof (inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }

        if (inputPages > 1) {
          return '多张/人'
        }
      },

      viewExam(index, rows) {
        // rows.splice(index, 1);

        var examID = rows[index].id
        // var course = rows[index].course
        var exam = rows[index].exam

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            // course: course,
            exam: exam
          }
        })
      },
      deleteForm(index, rows) {
        this.position = index
        this.selected_form_id = rows[index].id

        var state = rows[index].state

        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！', '提示', {

            confirmButtonText: '确定',
            callback: action => {
              this.function()
            }
          })
          // this.$message.error('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！')

          return
        }

        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据,导出可备份数据。如已备份且确实需要删除,请点"删除",否则请点击"取消"!'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
        }

        this.dialogVisible = true
      },
      delFormContentRecord() {
        let that = this
        this.dialogVisible = false

        // 调用删除接口
        var requestUrl = '/form/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            // that.loadDateList()

            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      tackbackForm(index, rows) {
        let that = this
        this.position = index
        this.selected_form_id = rows[index].id

        this.msg = '收回表格会停止填写表格,尚未填写的将不能继续填写,如要填写需要重新发放,要收回表格吗?'

        that.$confirm(this.msg, '操作提示', {
          confirmButtonText: '全部收回',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 收回表格
          var requestUrl = '/form/web/_tack_back_form.jsp'
          that.axios.get(requestUrl, {
              params: {
                form_id: that.selected_form_id
              }
            }).then(function(response) {
              // that.loadDateList()
              that.loadData()

              that.$message.success('收回成功！')
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        // this.$router.push('/import_excel'),
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = ''

        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            // that.current_download_file_name = fileName
            // that.current_download_file_name = response.data.download_file_path
            that.current_download_file_name = fileName
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_export_to_pdf.jsp'

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true

          that.current_download_file_name = response.data.pdf_filename

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadZip() {
        this.downloadZipDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.sendFormDialogVisible = true
      },
      browseData(index, rows) {
        var formId = rows[index].id
        var url = '/form/web/_browse_form_data.jsp?form_id=' + formId
        window.open(url)
      },
      openMakeForm() {
        this.$router.push('/make_form')
      },
      addGroupDetail() {
        this.addInputerNameDialogVisible = true
      },
      addInputerDetailList() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_save_inputer_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              group_id: that.group_id,
              group_content: that.group_detail
            }
          }).then(function(response) {
            that.addInputerNameDialogVisible = false
            that.group_name = ''
            that.group_detail = ''
            that.loadData()
            load.close()
            that.$message.success('添加成功！')
            // that.$forceUpdate()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      delInpterName(index) {
        this.position = index

        console.log(this.inputerDetailList)

        this.inputer_id = this.inputerDetailList[index].id

        this.msg = '要删除"' + this.inputerDetailList[index].inputer_name + '"吗?'

        this.dialogVisible = true
      },
      delInputerNameRecord() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_delete_inputer.jsp'
        this.axios.get(requestUrl, {
            params: {
              inputer_id: that.inputer_id
            }
          }).then(function(response) {
            that.dialogVisible = false
            that.loadData()
            load.close()
            that.$message.success('删除成功！')
            // that.$forceUpdate()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      back() {
        this.$router.push({
          name: 'inputer_list',
          params: {}
        })
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/inputer_list_detail.vue